/**
 * M6 Live Orders Popup - JavaScript
 */

// Array of sample orders for M6
const orders = [
    { name: "Chancy", location: "CA", product: "M(6) 1 Bottle", time: "11 minutes ago" },
    { name: "Douglas", location: "AZ", product: "M(6) 3 Bottles", time: "14 minutes ago" },
    { name: "Brian", location: "HI", product: "M(6) 1 Bottle", time: "18 minutes ago" },
    { name: "Anthony", location: "CA", product: "M(6) 1 Bottle", time: "21 minutes ago" },
    { name: "Carmencita", location: "ID", product: "M(6) 1 Bottle", time: "25 minutes ago" },
    { name: "Allyson", location: "HI", product: "M(6) 3 Bottles", time: "13 minutes ago" },
    { name: "Cynthia", location: "AZ", product: "M(6) 1 Bottle", time: "17 minutes ago" },
    { name: "Stacey", location: "CA", product: "M(6) 6 Bottles", time: "20 minutes ago" },
    { name: "Candace", location: "CA", product: "M(6) 6 Bottles", time: "24 minutes ago" },
    { name: "Ashley", location: "PA", product: "M(6) 1 Bottle", time: "14 minutes ago" },
    { name: "Deron", location: "NY", product: "M(6) 1 Bottle", time: "12 minutes ago" },
    { name: "Frederick", location: "NY", product: "M(6) 2 Bottles", time: "15 minutes ago" },
    { name: "Omar", location: "CA", product: "M(6) 1 Bottle", time: "18 minutes ago" },
    { name: "Karla", location: "TX", product: "M(6) 1 Bottle", time: "22 minutes ago" },
    { name: "Estefania", location: "CA", product: "M(6) 1 Bottle", time: "26 minutes ago" },
    { name: "Lisa", location: "TN", product: "M(6) 1 Bottle", time: "17 minutes ago" },
    { name: "Sam", location: "MA", product: "M(6) 6 Bottles", time: "21 minutes ago" },
    { name: "Fernando", location: "CA", product: "M(6) 1 Bottle", time: "24 minutes ago" },
    { name: "Roosevelt", location: "GA", product: "M(6) 1 Bottle", time: "27 minutes ago" },
    { name: "Jewel", location: "TX", product: "M(6) 1 Bottle", time: "31 minutes ago" },
    { name: "Chancy", location: "CA", product: "M(6) 1 Bottle", time: "13 minutes ago" },
    { name: "Alexander", location: "CA", product: "M(6) 1 Bottle", time: "16 minutes ago" },
    { name: "Marlon", location: "CA", product: "M(6) 1 Bottle", time: "20 minutes ago" },
    { name: "Linda", location: "TX", product: "M(6) 1 Bottle", time: "23 minutes ago" },
    { name: "Ashley", location: "PA", product: "M(6) 1 Bottle", time: "26 minutes ago" },
    { name: "Trevor", location: "UT", product: "M(6) 2 Bottles", time: "14 minutes ago" },
    { name: "Chanelle", location: "MA", product: "M(6) 1 Bottle", time: "18 minutes ago" },
    { name: "Nick", location: "VA", product: "M(6) 3 Bottles", time: "21 minutes ago" },
    { name: "Elizabeth", location: "CA", product: "M(6) 3 Bottles", time: "25 minutes ago" },
    { name: "Gregory", location: "SC", product: "M(6) 1 Bottle", time: "28 minutes ago" }
];

// Display popup function
function showLiveOrder() {
    const randomOrder = orders[Math.floor(Math.random() * orders.length)];
    const popup = document.getElementById('live-orders-popup');
    
    popup.innerHTML = `
        <div class="popup-content">
            <div class="popup-image">
                <img style="border-radius: 5px;" src="https://cdn.shopify.com/s/files/1/2443/2395/files/M6_Fat_Blocker_Zoom.png?v=1733360760" alt="Product Image">
                <span class="glow-dot"></span>
            </div>
            <div class="popup-text">
                <div class="popup-line">
                    <div class="name-location"><strong>${randomOrder.name} from ${randomOrder.location}</strong></div>
                </div>
                <div class="popup-line product-name"><span class="ordered-text">ordered</span> <strong><span class="product-text">${randomOrder.product}</span></strong></div>
                <div class="popup-line order-time">${randomOrder.time}</div>
                <div class="verified-buyer-badge">Verified Buyer</div>
            </div>
        </div>
    `;
    
    popup.style.display = 'block';

    setTimeout(() => {
        popup.classList.add('popup-hide');
    }, 6000);

    setTimeout(() => {
        popup.style.display = 'none';
        popup.classList.remove('popup-hide');
        setTimeout(showLiveOrder, getRandomTimeInterval());
    }, 6500);
}

// Random time intervals between popups
function getRandomTimeInterval() {
    const intervals = [20000, 20000, 20000]; // 20s, 20s, 20s
    return intervals[Math.floor(Math.random() * intervals.length)];
}

// Start the popup display
document.addEventListener('DOMContentLoaded', () => {
    setTimeout(showLiveOrder, getRandomTimeInterval());
});
